<div class="row row-sm">
  <div class="col-lg-12">
    <!-- <div class="card custom-card"> -->
    <div class="card-body">
      <div class="row">
        <div class="  col-md-12" *ngIf="submitButton">
          <div class="bc d-flex align-items-center pl-3">
            <img alt="Logo" src="../../assets/img/ExamMaster.png" class="mh-45px pb-2">
            <p class="mb-1">
              <span class="main-content-label"><b>Fee Template Mapping </b></span><br>
              <span class="text-muted card-sub-title mb-0">Add New Fee Template Mapping</span>
            </p>
          </div>
        </div>
        <div class="  col-md-12" *ngIf="editButton">
          <div class="bc d-flex align-items-center pl-3">
            <img alt="Logo" src="../../assets/img/CollegeMaster.png" class="mh-45px pb-2">
            <p class="mb-1">
              <span class="main-content-label"><b>Fee Template Mapping</b></span><br>
              <span class="text-muted card-sub-title mb-0">Upadte Fee Template Mapping</span>
            </p>
          </div>
        </div>
        <div class="  col-md-12" *ngIf="deleteButton">
          <div class="bc d-flex align-items-center pl-3">
            <img alt="Logo" src="../../assets/img/CollegeMaster.png" class="mh-45px pb-2">
            <p class="mb-1">
              <span class="main-content-label"><b>Fee Template Mapping</b></span><br>
              <span class="text-muted card-sub-title mb-0">Delete Fee Template Mapping</span>
            </p>
          </div>
        </div>
        <hr class="mt-3">
        <div class="row row-sm add-form">
          <form autocomplete="off" class="p-0" novalidate [formGroup]="feeMappingForm">
            <div class="col-lg-12 col-md-12">
              <div class="row clearfix">
                <div class="col-sm-6">
                  <div class="form-group">
                    <div class="">
                      <mat-form-field appearance="outline" class="example-full-width">
                        <mat-label>Session</mat-label>
                        <mat-select [disabled]="isreaddelete" #select232 placeholder="Session" class="colorblack"
                          formControlName="Session" required>
                          <mat-select-filter *ngIf="select232.focused" [placeholder]="'Filter'"
                            [displayMember]="'SnName'" [array]="sessionList"
                            (filteredReturn)="SessionFilterList =$event"></mat-select-filter>
                          <mat-option *ngFor="let item of SessionFilterList" [value]="item.SnNo">
                            {{item.SnName}}
                          </mat-option>
                        </mat-select>
                        <mat-error class="margin_tp"
                          *ngIf="feeMappingForm.controls['Session'].touched && feeMappingForm.controls['Session'].errors?.required">
                          Mandatory
                        </mat-error>
                      </mat-form-field>
                    </div>

                  </div>
                </div>
                <div class="col-sm-6">
                  <div class="form-group1">
                    <div class="">
                      <mat-form-field appearance="outline" class="example-full-width">
                        <mat-label>Faculty</mat-label>
                        <mat-select [disabled]="isreaddelete" required #select33 placeholder="" class="colorblack"
                          formControlName="Faculty">
                          <mat-select-filter *ngIf="select33.focused" [placeholder]="'Filter'"
                            [displayMember]="'FcDesc'" [array]="fcCodeList"
                            (filteredReturn)="filteredListFcCode =$event">
                          </mat-select-filter>
                          <mat-option *ngFor="let item of filteredListFcCode" [value]="item.FcCode"
                            (click)="getCourseData(item.FcCode)">
                            {{item.FcCode}} - {{item.FcDesc}}
                          </mat-option>
                        </mat-select>
                        <mat-error class="margin_tp"
                          *ngIf="feeMappingForm.controls['Faculty'].touched && feeMappingForm.controls['Faculty'].errors?.required">
                          Mandatory
                        </mat-error>
                      </mat-form-field>
                    </div>
                  </div>
                </div>
                <div class="col-sm-6">
                  <div class="form-group1">
                    <div class="">
                      <mat-form-field appearance="outline" class="example-full-width">
                        <mat-label>Course</mat-label>
                        <mat-select [disabled]="isreaddelete" required #select36 placeholder="" class="colorblack"
                          formControlName="Course">
                          <mat-select-filter *ngIf="select36.focused" [placeholder]="'Filter'"
                            [displayMember]="'CoName'" [array]="courseList"
                            (filteredReturn)="filteredCourseList =$event">
                          </mat-select-filter>
                          <mat-option *ngFor="let item of filteredCourseList"
                            (onSelectionChange)="getExamStreamData(item.CoCode)"
                            (click)="getExamStreamData(item.CoCode)" (click)="getExam(item)" 
                            [value]="item.CoCode" (click)="getFilterCourse(item.CoCode)">
                            {{item.CoCode}} - {{item.CoName}}
                          </mat-option>
                        </mat-select>
                        <mat-error class="margin_tp"
                          *ngIf="feeMappingForm.controls['Course'].touched && feeMappingForm.controls['Course'].errors?.required">
                          Mandatory
                        </mat-error>
                      </mat-form-field>
                    </div>
                  </div>
                </div>
                <div class="col-sm-6" *ngIf="!SelectAllActive">
                  <div class="form-group1">
                    <div class="">
                      <mat-form-field appearance="outline" class="example-full-width">
                        <mat-label>College</mat-label>
                        <mat-select  [disabled]="isreaddelete" required #select23 (selectionChange)="onCollegeSelectionChange($event)" placeholder="" class="colorblack"
                          formControlName="Colleges">
                          <mat-select-filter *ngIf="select23.focused" [placeholder]="'Filter'"
                            [displayMember]="'CgName'" [array]="CourseWisecollegeList"
                            (filteredReturn)="filteredCourseWisecollegeList =$event">
                          </mat-select-filter>
                          <mat-option *ngFor="let item of filteredCourseWisecollegeList" [value]="item.CoCgCgCode">
                            {{item.CoCgCgCode}} - {{item.CgName}}
                          </mat-option>
                        </mat-select>
                        <mat-error class="margin_tp"
                          *ngIf="feeMappingForm.controls['Colleges'].touched && feeMappingForm.controls['Colleges'].errors?.required">
                          Mandatory
                        </mat-error>
                      </mat-form-field>
                    </div>
                  </div>
                </div>
                <div class="col-sm-6" *ngIf="SelectAllActive">
                  <div class="form-group1">
                    <div class="">
                      <mat-form-field appearance="outline" class="example-full-width">
                        <mat-label>College</mat-label>
                        <mat-select  [disabled]="isreaddelete" required #select23 placeholder="" class="colorblack"
                          formControlName="Colleges" multiple>
                          <mat-select-filter *ngIf="select23.focused" [placeholder]="'Filter'"
                            [displayMember]="'CgName'" [array]="CourseWisecollegeList"
                            (filteredReturn)="filteredCourseWisecollegeList =$event">
                          </mat-select-filter>
                          <mat-option *ngIf="collegeListData" (click)="selectAllColleges()" [value]="'selectAll'" [checked]="isAllCollegesSelected()">
                            Select All
                        </mat-option>
                          <mat-option *ngFor="let item of filteredCourseWisecollegeList" disabled [value]="item.CoCgCgCode" [checked]="selectedColleges.includes(item.CoCgCgCode)"> 
                            {{item.CoCgCgCode}} - {{item.CgName}}
                          </mat-option>
                        </mat-select>
                        <mat-error class="margin_tp"
                          *ngIf="feeMappingForm.controls['Colleges'].touched && feeMappingForm.controls['Colleges'].errors?.required">
                          Mandatory
                        </mat-error>
                      </mat-form-field>
                    </div>
                  </div>
                </div>
                <div class="col-sm-6">
                  <div class="form-group">
                    <div class="">
                      <mat-form-field appearance="outline" class="example-full-width">
                        <mat-label>
                          Exam
                        </mat-label>

                        <mat-select [disabled]="isreaddelete" required #select56 class="colorblack"
                          formControlName="EmId">
                          <mat-select-filter *ngIf="select56.focused" [placeholder]="'Filter'"
                            [displayMember]="'EmName'" [array]="examList" (filteredReturn)="filteredListExam =$event">
                          </mat-select-filter>
                          <mat-option *ngFor="let item of filteredListExam" [value]="item.EmId" (click)="getSem(item)">
                            {{item.EmCode}} - {{item.EmName}}
                          </mat-option>
                        </mat-select>
                        <mat-error class="margin_tp"
                          *ngIf="feeMappingForm.controls['EmId'].touched && feeMappingForm.controls['EmId'].errors?.required">
                          Mandatory
                        </mat-error>
                      </mat-form-field>
                    </div>
                  </div>
                </div>
                <div class="col-sm-6" *ngIf="SemDrp">
                  <div class="form-group">
                    <div class="">
                      <mat-form-field appearance="outline" class="example-full-width">
                        <mat-label>
                          Semester
                        </mat-label>

                        <mat-select [disabled]="isreaddelete" #select57 class="colorblack" formControlName="Sem">
                          <mat-select-filter *ngIf="select57.focused" [placeholder]="'Filter'"
                            [displayMember]="'SeName'" [array]="semList" (filteredReturn)="filteredListSem =$event">
                          </mat-select-filter>
                          <mat-option *ngFor="let item of filteredListSem" [value]="item.SeCode">
                            {{item.SeCode}} - {{item.SeName}}
                          </mat-option>
                        </mat-select>
                        <mat-error class="margin_tp"
                          *ngIf="feeMappingForm.controls['Sem'].touched && feeMappingForm.controls['Sem'].errors?.required">
                          Mandatory
                        </mat-error>
                      </mat-form-field>
                    </div>
                  </div>
                </div>
                <div class="col-sm-6" *ngIf="showBranch">
                  <div class="form-group">
                    <mat-form-field appearance="outline" class="example-full-width">
                      <mat-label>Branch</mat-label>
                      <mat-select [disabled]="isreaddelete " #select301 placeholder="Branch" class="colorblack"
                        formControlName="Branch">
                        <mat-select-filter *ngIf="select301.focused" [placeholder]="'Filter'"
                          [displayMember]="'StrName'" [array]="courseStreamList"
                          (filteredReturn)="filteredStreamList =$event"></mat-select-filter>
                        <mat-option *ngFor="let item of filteredStreamList" [value]="item.StrCode">
                          {{item.StrName}}
                        </mat-option>
                      </mat-select>
                      <mat-error class="margin_tp"
                        *ngIf="feeMappingForm.controls['Branch'].touched && feeMappingForm.controls['Branch'].errors?.required">
                        Mandatory
                      </mat-error>
                    </mat-form-field>
                  </div>
                </div>
                <div class="col-sm-6">
                  <div class="form-group">
                    <div class="">
                      <mat-form-field appearance="outline" class="example-full-width">
                        <mat-label>
                          College Type
                        </mat-label>
                        <mat-select [disabled]="isreaddelete" #select333 required class="colorblack"
                          formControlName="CollegeType">
                          <mat-select-filter *ngIf="select333.focused" [placeholder]="'Filter'"
                            [displayMember]="'CdDesc'" [array]="cgtypeList"
                            (filteredReturn)="filteredcgtypeList =$event"></mat-select-filter>
                          <mat-option *ngFor="let item of filteredcgtypeList" [value]="item.CdCode">
                            {{item.CdDesc}}
                          </mat-option>
                        </mat-select>
                        <mat-error class="margin_tp"
                          *ngIf="feeMappingForm.controls['CollegeType'].touched && feeMappingForm.controls['CollegeType'].errors?.required">
                          Mandatory
                        </mat-error>
                      </mat-form-field>

                    </div>
                  </div>
                </div>
                <div class="col-sm-6">
                  <div class="form-group">
                    <mat-form-field appearance="outline" class="example-full-width">
                      <mat-label>Fee Type
                      </mat-label>
                      <mat-select required #select343 [disabled]="isreaddelete" class="colorblack"
                        formControlName="FeeType">
                        <mat-select-filter *ngIf="select343.focused" [placeholder]="'Filter'" [displayMember]="'CdDesc'"
                          [array]="feeList" (filteredReturn)="filteredfeeList =$event">
                        </mat-select-filter>
                        <mat-option *ngFor="let item of filteredfeeList" [value]="item.CdCode"
                          (click)="getFeeTempletData(item.CdCode)">
                          {{item.CdDesc}}
                        </mat-option>
                      </mat-select>
                      <mat-error class="margin_tp"
                        *ngIf="feeMappingForm.controls['FeeType'].touched && feeMappingForm.controls['FeeType'].errors?.required">
                        Mandatory
                      </mat-error>
                    </mat-form-field>

                  </div>
                </div>
                <div class="col-sm-6">
                  <div class="form-group">
                    <mat-form-field appearance="outline" class="example-full-width">
                      <mat-label>Fee Templet
                      </mat-label>
                      <!-- <mat-select required #select343 [disabled]="isreaddelete"
                       class="colorblack" formControlName="FeeTemplate">
                        <mat-select-filter *ngIf="select343.focused" [placeholder]="'Filter'" 
                        [displayMember]="'TemplateName'" [array]="filteredFeeTempletList"
                          (filteredReturn)="filteredFeeTempletList2 = $event">
                        </mat-select-filter>
                        <mat-option *ngFor="let item of filteredFeeTempletList2" [value]="item.TemplateCode">
                          {{ item.TemplateCode }} - {{ item.TemplateName }}
                        </mat-option>
                      </mat-select> -->


                      <mat-select required #select343 [disabled]="isreaddelete" class="colorblack"
                        formControlName="FeeTemplate">
                        <mat-select-filter *ngIf="select343.focused" [placeholder]="'Filter'" [displayMember]="'TemplateName'"
                          [array]="filteredFeeTempletList" (filteredReturn)="filteredFeeTempletList2 =$event">
                        </mat-select-filter>
                        <mat-option *ngFor="let item of filteredFeeTempletList2" [value]="item.TemplateCode">
                          {{ item.TemplateCode }} - {{ item.TemplateName }}
                        </mat-option>
                      </mat-select>
                      <mat-error class="margin_tp"
                        *ngIf="feeMappingForm.controls['FeeTemplate'].touched && feeMappingForm.controls['FeeTemplate'].errors?.required">
                        Mandatory
                      </mat-error>
                    </mat-form-field>
                  </div>
                </div>
                <!-- <div class="col-sm-12">
                          <button type="button"
                              class="btn btn-primary my-2 me-2 mt-0 btn-icon-text floatright btn-raised g-bg-blush2"
                              *ngIf="submitButton && feeCreate" (click)="save()">Save</button>
                          <button type="button"
                              class="btn btn-primary my-2 me-2 btn-icon-text floatright btn-raised g-bg-blush2"
                              *ngIf="editButton && feeUpdate" (click)="update()">{{'header.faculty-data.titleList.Update' | translate}}</button>
                          <button type="button"
                              class="btn btn-primary my-2 me-2 btn-icon-text floatright btn-raised g-bg-blush2"
                              *ngIf="deleteButton && feeDelete" (click)="DeletetheRecord()">{{'header.faculty-data.titleList.Delete' | translate}}</button>
                          <button type="button"
                              class="mat-focus-indicator mat-menu-trigger btn btn-white btn-icon-text my-2 me-2 floatright mat-button mat-button-base"
                              (click)="addnewrecord('false')">Back</button>
                      </div> -->
                <div class="row prpl">
                  <div class="col-sm-12">
                    <button type="button" *ngIf="submitButton && feeCreate"
                      class="btn btn-primary btn-icon-text floatright sz fr mt-1" (click)="save()">
                      <span style="display: contents; align-items: center;">
                        <img width="20vh" src="../../assets/img/save.gif" style="margin-right: 5px;">
                        Save
                      </span>
                    </button>
                    <button type="button" *ngIf="editButton && feeUpdate"
                      class="btn btn-primary btn-icon-text floatright sz fr mt-1" (click)="update()">
                      <span style="display: contents; align-items: center;">
                        <img width="20vh" src="../../assets/img/edit1.gif" style="margin-right: 5px;">
                        Update
                      </span>
                    </button>
                    <button type="button" *ngIf="deleteButton && feeDelete"
                      class="btn btn-primary btn-icon-text floatright sz fr mt-1" (click)="DeletetheRecord()">
                      <span style="display: contents; align-items: center;">
                        <img width="20vh" src="../../assets/img/trash.gif" style="margin-right: 5px;">
                        Delete
                      </span>
                    </button>
                    <button type="button" [mat-dialog-close]="true"
                      class="btn btn-primary btn-icon-text floatright sz fr mt-1">
                      <span style="display: contents; align-items: center;">
                        <img width="20vh" src="../../assets/img/turn-left.gif" style="margin-right: 5px;">
                        Back
                      </span>
                    </button>
                  </div>

                </div>
              </div>
              <!-- </div>
          </div> -->
            </div>
          </form>
        </div>
      </div>
    </div>
    <!-- </div> -->
  </div>
</div>